import React from 'react';
import PropTypes from 'prop-types';
import './OnboardingCompleted.scss';
import LazyFinish from '../Finish/LazyFinish';
import onboardingCompleted from '../../../../assets/images/onboarding-completed.svg';
import { analyticsTrack } from '../../../analyticsUtils';
function OnboardingCompleted(_ref) {
  var csrfToken = _ref.csrfToken,
    profileUrl = _ref.profileUrl,
    userId = _ref.userId,
    onboardType = _ref.onboardType;
  var onViewProjects = function onViewProjects() {
    analyticsTrack('Clicking on View Projects', {
      location: 'Onboarding Flow',
      userId: userId
    });
  };
  var onAddProfileDetails = function onAddProfileDetails() {
    analyticsTrack('Clicking on View Profile', {
      location: 'Onboarding Flow',
      userId: userId
    });
  };
  if (onboardType === 'lazy_onboard') {
    return /*#__PURE__*/React.createElement(LazyFinish, {
      csrfToken: csrfToken,
      onboardType: onboardType
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "onboarding-completed "
  }, /*#__PURE__*/React.createElement("div", {
    className: "completed-container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Completed Checklist",
    src: onboardingCompleted,
    className: "completed-image"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "header"
  }, "All done!"), /*#__PURE__*/React.createElement("div", {
    className: "text-1"
  }, "We have all the information we need to start matching you with employers."), /*#__PURE__*/React.createElement("div", {
    className: "text-2"
  }, "You may now", ' ', /*#__PURE__*/React.createElement("strong", null, "view available projects"), ' ', "that match your profile. You may also continue to", ' ', /*#__PURE__*/React.createElement("strong", null, "add detail to your profile"), ' ', "to receive even more relevant project listings."), /*#__PURE__*/React.createElement("div", {
    className: "btn-container mt-40"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary view-project-btn",
    id: "view-project-link",
    onClick: function onClick() {
      return onViewProjects();
    },
    href: "/opportunities"
  }, "View projects"), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary add-to-profile-btn",
    id: "add-profile-link",
    onClick: function onClick() {
      return onAddProfileDetails();
    },
    href: profileUrl
  }, "View Profile"))), /*#__PURE__*/React.createElement("div", {
    className: "mobile-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar navbar-expand-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "navbar-toggler collapsed",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#clora-footer-navbar",
    "aria-label": "Toggle navigation",
    "aria-expanded": "false"
  }, /*#__PURE__*/React.createElement("span", {
    className: "navbar-toggler-icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "navbar-text navbar-brand"
  }, "\xA9", ' ', new Date().getFullYear(), ' ', "Clora")), /*#__PURE__*/React.createElement("div", {
    className: "collapse navbar-collapse",
    id: "clora-footer-navbar"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav navbar-nav navbar-right"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/privacy-policy"
  }, "Privacy Policy")))))));
}
OnboardingCompleted.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  onboardType: PropTypes.string.isRequired
};
export default OnboardingCompleted;